import HttpAuth from "./authHttp";

const service = HttpAuth.getInstance();

export default service;
